/* eslint-disable no-return-assign */
/* eslint-disable no-param-reassign */
import sysend from 'sysend';
import { useHistory } from 'react-router-dom';
import queryString from 'query-string';
import { initCommonTranslate } from 'Utils/languages';
import { getFeatureFlags, getEnv } from 'Utils/featureFlagUtils';
import { getAuthenticatedUser } from '../../../app/src/api/authApi';
import { useGlobal } from './reactn/useGlobal';
import useDebug from './debug';
import appStore from '../../../app/src/store/appStore';
import useAuthProvider from './authProvider';
import sha1 from 'js-sha1';
import { jwtDecode } from 'jwt-decode';
import { getLanguageCode } from 'Utils/languages';
import { VITE_NEW_AUTH_TOKEN_TIME, VITE_MSIE11, VITE_EDGE } from 'Constants/appEnvConstants';
import LogRocket from '../../../app/src/store/logrocket';
import { eventEmitter, resetInactivityTimer } from './gpAuthService';

let auth;
let setAuth;
let setAccess;
let setUserAdmin;
let setPreferences;
let initialized = false;
let timedOut = false;

export function logRocketSessionInitializer(accessToken){   
  const parsedToken = jwtDecode(accessToken);
  const email = parsedToken.email;
  const firstName = parsedToken.given_name;
  const lastName= parsedToken.family_name;
  const name =`${firstName} ${lastName}`;
  LogRocket.identify('THE_USER_ID_IN_YOUR_APP', {
    name: name ,    
    email: email, 
    // Add your own custom user variables here, ie:
    subscriptionType: 'pro'
  });

}

function getFormattedRoleName(roleName){
  switch(roleName){
    case 'applications.dims.role.dimsAcquirerAdmin.name' :
      return 'Acquirer Admin';
    case 'applications.dims.role.dimsAccountAdmin.name' :
      return 'Account Admin';
    case 'applications.dims.role.dimsAcquirerUser.name' :
      return 'Acquirer User';
      case 'applications.dims.role.dimsAccountUser.name' :
        return 'Account User';
    default:
      return roleName;
  }
}


export function pendoInitializer(accessToken) {

      let sessionState = JSON.parse(sessionStorage.getItem("state"));
      let authUser = sessionState.auth.user;
      let roleName = authUser?.role?.key;
      let location = authUser?.location;
      let dimsRole = authUser?.role?.name?.includes('applications.dims.role') ? getFormattedRoleName(authUser.role.name) : authUser?.role?.name;
      if( !authUser || !roleName || !location || !dimsRole) { 
           getAuthenticatedUser(accessToken)
                  .then((userResponse) => {
              authUser = userResponse.data;
              roleName = authUser.role.key;
              location = authUser.location;
			  dimsRole = authUser?.role?.name?.includes('applications.dims.role') ? getFormattedRoleName(authUser.role.name) : authUser.role.name;
                  }).catch((error) => {
                        console.log(error);
                  });
      }
      const externalUsers = ['DiMS_ACCOUNT_ADMIN', 'DiMS_ACCOUNT_USER', 'DiMS_ACQUIRER_ADMIN', 'DiMS_ACQUIRER_USER'];
      if (externalUsers.includes(roleName)) {
        if (location == 'UK' || location == 'MX'){
          pendo.stopSendingEvents();
        }
        else {
          pendoInit(authUser);
        }
      }
      else {
        pendoInit(authUser);
      }
}

const pendoInit = (authUser) => {
  const email = authUser?.email;
  const roleName = authUser?.role?.key;
  const appEnv = getEnv(window.location.hostname);
  const hashedEmail = sha1(`${email}-${appEnv}`);
  const languageAbbr = getLanguageCode(authUser?.languageAbbr);
  const location = authUser?.location;
  const acquirerId = authUser?.acquirerId;
  const acquirerCode = authUser?.acquirerCode[0];
  const dimsRole = authUser?.role?.name?.includes('applications.dims.role') ? getFormattedRoleName(authUser.role.name) : authUser.role.name;
  pendo?.initialize({
    sanitizeUrl: function (url) {
      const blacklist = ['token', 'state='];
      const hasSensitiveInfo = blacklist?.find(key => url && url.toLowerCase().includes(key));
      return hasSensitiveInfo ? url.split('#')[0].split('?')[0] : url;
    },
    visitor: {
      id: hashedEmail,
      region : location,
      userLanguage : languageAbbr,
      acquirerCode : acquirerCode,
      roleName,
      appEnv,
	  dimsRoleName : dimsRole
    },
    account: {
      id: acquirerId
    },
    excludeAllText: true
  });

}

const useSession = () => {
  [auth, setAuth] = useGlobal('auth');
  [, setAccess] = useGlobal('access');
  [, setUserAdmin] = useGlobal('userAdmin');
  [, setPreferences] = useGlobal('preferences');
  const [, setFeatureFlag] = useGlobal('featureFlags');
  const reportsList = [];

  const debug = useDebug(false);
  const authProvider = useAuthProvider();
  const history = useHistory();
  // const authApi = useApi('Auth');
  //const userApi = useApi('Users');
  //const translations = useTranslations();
  const [, setProducts] = useGlobal('products');
  const dashboardPage = 'CAN_VIEW_DASHBOARD_PAGE';

  //const { setUpTranslationDefaults } = useTranslations();
  // when all tabs receive a response, set isRequesting to false to ensure only one tab responds to the original request
  let isRequesting = false;

  // true if this tab is currently authenticated
  const isTabAuthenticated = (auth) => {
    return auth.accessToken !== undefined;
  };

  const isAuthenticated = () => {
    return sessionStorage.getItem("__gp_auth_token__") !== undefined;
  };

  const isDashBoardLandingPage = () => {
    if (auth.session.user.role.key === 'CUSTOM_USER') {
      if (auth.session && auth.session.sessionToken !== undefined && auth.session.user.role.permissions) {
        let dashBoard;
        auth.session.user.role.permissions.map((item) => {
          if (item.key === dashboardPage) {
            dashBoard = true;
          }
        });
        return dashBoard;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  const isLoggingIn = () => {
    return auth.isLoggingIn;
  };

  const isRegistering = () => {
    return auth.isRegistering;
  };

  const initializeSession = (message) => {
    debug(`received message ${message}`)
    debug(`token: ${message.token} expiry : ${message.expiry}`);
    var sessionState = JSON.parse(sessionStorage.getItem('state'));
    sessionState.auth.accessToken = message.token;
    sessionState.auth.tokenExpiry = message.expiry;
    sessionState.auth.otherTabActive = message.otherTabActive;
    setAuth(newAuth => {
      newAuth.accessToken = message.token,
        newAuth.tokenExpiry = message.expiry,
        newAuth.otherTabActive = message.otherTabActive
    });
    sessionStorage.setItem('state', JSON.stringify(sessionState))
  };

  const resetAuth = () => {
    setAuth(newAuth => {
      newAuth.session = {};
      newAuth.isLoggingIn = false;
    });
  };

  const completeRegistration = () => {
    initializeSession(auth.session.sessionToken)
      .then(() => {
        setAuth(newAuth => {
          newAuth.isRegistering = false;
          newAuth.isSelfRegistered = true;
        });
        setProducts(p => {
          // reset product save status after self-registration
          // todo: once ProductSelection is refactored, move this logic there
          p.isSaveCompleted = false;
        });
        history.push('/');
      });
  };
  // login and broadcast auth token to any other MP tabs (same-origin)
  const login = () => {
    debug('[session.js] login() called');
    const accessToken = sessionStorage.getItem("__gp_auth_token__");
    
    if (accessToken) {
      logRocketSessionInitializer(accessToken);
      console.log('********* Logrocket identified *********');
      try {
        pendoInitializer(accessToken);
      } catch (error) { 
        console.log("Pendo initialization error:", error); 
      }
      
      const loginObject = { 
        token: accessToken, 
        expiry: Date.now() + VITE_NEW_AUTH_TOKEN_TIME, 
        otherTabActive: false 
      };
      sysend.broadcast('session.response', loginObject);
      return;
    }
    
    if (auth.isLoggingIn) return;
    
    debug('[session.js] No token found, will trigger login');
    setTimeout(() => {
      if (!isAuthenticated()) authProvider.signinByRedirect();
    }, 200);
  };

  // broadcast the token if it's being requested, we have a token, and no other tab has responded yet
  const broadcastToken = () => {
    debug(`Responding to a request for token: ${isRequesting}`);
    if (isAuthenticated() && isRequesting) {
      debug('Broadcasting the requested session token');
      sysend.broadcast('session.response', { token: JSON.parse(sessionStorage.getItem("state")).auth.accessToken, expiry: JSON.parse(sessionStorage.getItem("state")).auth.tokenExpiry, otherTabActive: false });
      isRequesting = false;
    }
  };

  // called when a request for a pre-existing session token is received from another tab
  const handleTokenRequestFromTab = () => {
    debug('Request received from a tab for a session token');
    // update status to indicate a request in progress and respond if we have the token
    isRequesting = true;
    if (isAuthenticated()) {
      debug(`Will respond with: ${JSON.parse(sessionStorage.getItem("state")).auth.accessToken}`);
      // delay random ms so multiple tabs don't respond at exactly the same time
      setTimeout(broadcastToken, Math.floor(Math.random() * 100));
    }
  };

  // called when a tab has logged in or responded to a token request
  const handleTokenResponseFromTab = (msg) => {
    debug(`Another tab has responded with a session token: ${msg.token}`);
    // Update state to indicate we are no longer in a request and update the auth token to the broadcasted value
    isRequesting = false;
    if (msg.token) {
      initializeSession(msg);
    }
  };

  //commenting below method as we are checking for user activity every 5 min and is handled in SessionMonitor.js
  /* const shouldRenew = (tokenExpiry) => {
    const tokenExpiresInMs = JSON.parse(sessionStorage.getItem("state")).auth.tokenExpiry - Date.now();
    debug('in shouoldrenew remaining,storageVal,receivedVal',tokenExpiresInMs,JSON.parse(sessionStorage.getItem("state")).auth.tokenExpiry,tokenExpiry)
    return tokenExpiresInMs < (VITE_RENEW_AUTH_TOKEN_TIME);
  }; */

  const renew = () => {
    console.log('[session.js] renew() called - using GP Auth token refresh');
    
    let accessToken = sessionStorage.getItem("__gp_auth_token__");
    if (!accessToken) {
      // Try fallback from Redux state
      const authObject = JSON.parse(sessionStorage.getItem("state"))?.auth;
      if (authObject?.accessToken) {
        accessToken = authObject.accessToken;
        console.log('[session.js] Using token from Redux state fallback');
      } else {
        return Promise.reject('No token to renew');
      }
    }
    
    resetInactivityTimer();
    
    return new Promise((resolve, reject) => {
      const state = JSON.parse(sessionStorage.getItem("state"));
      
      // Set up listener for token refresh event
      const onTokenRefresh = (newToken) => {
        console.log("[session.js] ========== OnTokenRefresh event FIRED ==========");
        console.log("[session.js] New token received:", newToken);
        
        const returnValue = {
          token: newToken,
          expiry: Date.now() + VITE_NEW_AUTH_TOKEN_TIME,
          otherTabActive: true
        };
        
        // Clean up the event listener
        eventEmitter.off("OnTokenRefresh", onTokenRefresh);
        
        resolve(returnValue);
      };
      
      // Register the event listener
      eventEmitter.on("OnTokenRefresh", onTokenRefresh);
      
      // Set a timeout in case token refresh doesn't happen
      setTimeout(() => {
        eventEmitter.off("OnTokenRefresh", onTokenRefresh);
        console.log("[session.js] Token refresh timeout - checking for latest token");
        
        resolve({ 
          token: sessionStorage.getItem("__gp_auth_token__") || 
                 JSON.parse(sessionStorage.getItem("state"))?.auth?.accessToken || 
                 accessToken,
          expiry: JSON.parse(sessionStorage.getItem("state"))?.auth?.tokenExpiry || 
                  (Date.now() + VITE_NEW_AUTH_TOKEN_TIME), 
          otherTabActive: true 
        });
      }, 5000); // 5 second timeout
    });
  };

  const timeOut = () => {
    timedOut = true;
    history.push('/logout');
  }

  const isTimedOut = () => {
    return timedOut;
  }

  // logout and broadcast to all tabs if this tab originated the logout request
  const logout = async (fromAnotherTab = false) => {
    // setAuth({ token: null, initialized: true, isLoggedIn: false });
    if (!fromAnotherTab) {
      if (!VITE_MSIE11 && !VITE_EDGE) window.stop();
      pendo.clearSession();
      console.log('********* Pendo session cleared *********');      
      var sessionState = JSON.parse(sessionStorage.getItem('state'));
      console.log("session logout",JSON.stringify(sessionState));
      console.log("sessionStorage",sessionStorage.getItem('__gp_auth_token__'));
      sessionStorage.setItem('state', JSON.stringify(sessionState))
      appStore({});
      await authProvider.signoutFromProvider();
    } else {
      pendo.clearSession();
      console.log('********* Pendo session cleared from another tab *********');  
      history.push('/logout');
    }
  };

  const tearDown = () => {
    // if (!VITE_MSIE11 && !VITE_EDGE) window.stop();
    initialized = false;
    sessionStorage.removeItem('state');
    appStore({});
    sysend.off('session.request');
    sysend.off('session.response');
    sysend.on('session.response', (msg) => {
      initializeSession(msg.token).then(() => {
        history.push('/');
      });
    });
  };

  // only initialize this session one time for this browser tab
  if (initialized !== true) {
    // setAuth({ ...auth, initialized: true });
    debug('auth here', auth)
    debug('Initializing this tab auth setup');
    initialized = true;
    sysend.on('session.request', handleTokenRequestFromTab);
    sysend.on('session.response', handleTokenResponseFromTab);
    // let any other tabs know we started up and need a session token if one exists
    debug('Broadcasting request for a session');
    sysend.broadcast('session.request');

    eventEmitter.on("OnTokenRefresh", (newToken) => {
    console.log(
      "[session.js] ========== OnTokenRefresh event FIRED =========="
    );

    if (newToken) {
      // sessionStorage.setItem("accessToken", newToken);
      const sessionState = JSON.parse(sessionStorage.getItem("state"));
      if (sessionState && sessionState.auth) {
        sessionState.auth.accessToken = newToken;
        sessionState.auth.tokenExpiry = Date.now() + VITE_NEW_AUTH_TOKEN_TIME;
        sessionStorage.setItem("state", JSON.stringify(sessionState));
      }

      const expiry = Date.now() + VITE_NEW_AUTH_TOKEN_TIME;
      sysend.broadcast("session.response", {
        token: newToken,
        expiry: expiry,
        otherTabActive: true,
      });
      sysend.broadcast("session.userActivity");
    }
  });
  }

  return {
    isAuthenticated,
    isTabAuthenticated,
    isDashBoardLandingPage,
    login,
    logout,
    renew,
    tearDown,
    resetAuth,
    isLoggingIn,
    isRegistering,
    completeRegistration,
    timeOut,
    isTimedOut,
  };
};
export default useSession;
